import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const rows = [{
  llm: 'Non-deterministic',
  need: 'Repeatability'
}, {
  llm: 'Stateless',
  need: 'Firm memory'
}, {
  llm: 'Generic',
  need: 'Industry specialization'
}, {
  llm: 'Public / general data oriented',
  need: 'Proprietary data'
}, {
  llm: 'Expensive at scale',
  need: 'Efficient model routing'
}, {
  llm: 'Blank-prompt workflows',
  need: 'Structured workflows'
}];
export function LlmLimitsOverviewSlide() {
  return <Slide variant="deep" data-id="element-306" data-mp="3j2jq5zup4gmm">
      <Eyebrow data-id="element-307" data-mp="3j3crumessfxw">Why general LLMs are not enough</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[70%]" data-id="element-308" data-mp="3o1e86zkua15o">
        Powerful models. Not built for institutional diligence.
      </Title>

      <div className="mt-auto" data-id="element-309" data-mp="1haoj5xjdx0aq">
        <div className="grid grid-cols-[4cqw_1fr_5cqw_1fr] border-b border-white/15 pb-[1.6cqh]" data-id="element-310" data-mp="1m8ydk5xabwva">
          <span data-id="element-311" data-mp="3wpq177z6pbc" />
          <Label data-id="element-312" data-mp="3w67boai3ww9">General LLMs</Label>
          <span data-id="element-313" data-mp="3v4w9jthjaej" />
          <Label tone={INK.blue} data-id="element-314" data-mp="3uldk0w0ghzg">Institutional diligence requires</Label>
        </div>
        {rows.map((r, i) => <Reveal key={r.llm} delay={0.05 * i} className="grid grid-cols-[4cqw_1fr_5cqw_1fr] items-baseline border-b border-white/8 py-[2.1cqh]" data-id="element-315" data-mp="cp03cxe63awt" data-mpi={i}>
            <span className="text-[0.8cqw] tracking-[0.22em] text-white/35" data-id="element-316" data-mp="8pscywi8z0ik">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span className="text-[1.75cqw] leading-none text-[#6B7588]" style={SERIF} data-id="element-317" data-mp="3c4wm8l44sd6o">
              {r.llm}
            </span>
            <span className="text-[1.3cqw] leading-none text-[#3B8CFF]" aria-hidden data-id="element-318" data-mp="3q5h5tjhved18">
              →
            </span>
            <span className="text-[1.75cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-319" data-mp="3l75zhiqsaknr">
              {r.need}
            </span>
          </Reveal>)}
      </div>
    </Slide>;
}